<template>
    <div class="modal-overlay">
        <div class="modal-content">
            <h3>{{ $t('edit-program') }}</h3>
            <form @submit.prevent="saveChanges">
                <div class="form-group">
                    <label for="programName">{{ $t('program-name') }}</label>
                    <input v-model="program.name" id="programName" type="text" class="form-control" required />
                </div>
                <div class="form-group">
                    <label for="courseLength">{{ $t('course-length') }}</label>
                    <input v-model="program.courselengthyears" id="courseLength" type="number" class="form-control" required />
                </div>
                <div class="modal-actions">
                    <button type="button" class="btn btn-secondary" @click="close">{{ $t('cancel') }}</button>
                    <button type="submit" class="btn btn-primary">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import "@/styles/components/programmeUpdate.scss"; 

export default {
    props: {
        program: Object,
    },
    methods: {
        saveChanges() {

            this.$cfetch(`${this.$settings.APIBaseURL}/programmes/update`, {
                method: 'POST',
                data: {
                    id: this.program.id,
                    name: this.program.name,
                    courselengthyears: Number(this.program.courselengthyears),
                },
            }).then((res) => {

                if (res.status === 'SUCCESS') {
                    
                    this.$emit('save');
                    this.close();
                } else {
                    this.$store.commit("openDialog", {
                        title: this.$t("something-went-wrong"),
                        content: this.$t('program-update-failed'),
                        confirmCallBack: function () {},
                    });
                }
            }).catch((error) => {
                console.error("Error while updating program:", error); // Log any errors
            });
        },
        close() {
            this.$emit('close');
        },
    }
};
</script>